import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach admin token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("wan_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Public helpers
export const getHomepage = () => api.get("/homepage").then((r) => r.data);
export const getSettings = () => api.get("/settings").then((r) => r.data);
export const getTours = (params) => api.get("/tours", { params }).then((r) => r.data);
export const getTour = (slug) => api.get(`/tours/${slug}`).then((r) => r.data);
export const getTourCategories = () => api.get("/tours/categories").then((r) => r.data);
export const getDestinations = (params) => api.get("/destinations", { params }).then((r) => r.data);
export const getDestination = (slug) => api.get(`/destinations/${slug}`).then((r) => r.data);
export const getBlog = (params) => api.get("/blog", { params }).then((r) => r.data);
export const getPost = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);
export const getTestimonials = (params) => api.get("/testimonials", { params }).then((r) => r.data);
export const getFaqs = (params) => api.get("/faqs", { params }).then((r) => r.data);
export const submitEnquiry = (payload, recaptchaToken = null) =>
  api
    .post("/enquiries", payload, recaptchaToken ? { headers: { "X-Recaptcha-Token": recaptchaToken } } : undefined)
    .then((r) => r.data);
export const getPage = (slug) => api.get(`/pages/${slug}`).then((r) => r.data).catch(() => null);

export default api;
